define("shared/utils/post-tagging/post-tagging", ["exports", "shared/types/post-tagging"], function (_exports, _postTagging) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.convertTagToApiTag = _exports.convertApiTagToTag = void 0;
  0; //eaimeta@70e063a35619d71f0,"shared/types/post-tagging"eaimeta@70e063a35619d71f
  const convertApiTagToTag = t => {
    return {
      id: t.id,
      name: t.name,
      data: t.data,
      groupId: t.group_id,
      tagType: _postTagging.ReverseTagTypeMap[t.tag_type]
    };
  };
  _exports.convertApiTagToTag = convertApiTagToTag;
  const convertTagToApiTag = t => {
    return {
      id: t.id,
      name: t.name,
      data: t.data,
      group_id: t.groupId,
      tag_type: _postTagging.TagTypeMap[t.tagType]
    };
  };
  _exports.convertTagToApiTag = convertTagToApiTag;
});